'use strict';

export default angular.module('fplTruescapeComApp.slideableDirective', [])
  .directive('slidable', TranslationManager => {
    TranslationManager.init();
    return {
      restrict: 'E',
      compile: (element, attributes) => {
        let slideTabMessages = attributes.slideTabTooltipMessage.split('|');
        // calling TranslationManager to transdlate our tab messages
        var translatedSlideTabMessages = slideTabMessages.map(slideTabMessage => {
          return TranslationManager.getReference(slideTabMessage);
        });
        let siteBanner = document.getElementsByClassName('showSiteBanner')[0];
        siteBanner.insertAdjacentHTML('afterbegin',
          '<div id="sliderSwitch" tooltip-placement="top" uib-tooltip="{{tooltipMessage}}" tooltip-class="tooltip-altalink"><i id="sliderSwitchIcon"></i></div>'
        );
        return {
          pre: scope => {
            // default message for tooltip
            scope.tooltipMessage = translatedSlideTabMessages[0];
          },
          post: (scope, element, attributes) => {
            let sliderSwitch = document.getElementById('sliderSwitch');
            let sliderSwitchIcon = document.getElementById('sliderSwitchIcon');
            let sliderSwitchIconClasses = attributes.slideTabIcons.split('|');
            sliderSwitchIcon.className = sliderSwitchIconClasses[0]; //default class
            sliderSwitchIcon.addEventListener('click', () => {
              siteBanner.classList.toggle('hideSiteBanner');
              // swapping icon font-awesome classes
              sliderSwitchIcon.className = sliderSwitchIcon.className ===
                sliderSwitchIconClasses[0] ?
                sliderSwitchIconClasses[1] :
                sliderSwitchIconClasses[0];
              // gettind and then setting the 'ui-tooltip' text every time the banner slides up or down
              sliderSwitch.getAttribute('uib-tooltip') === translatedSlideTabMessages[0] ?
                scope.tooltipMessage = translatedSlideTabMessages[1] :
                scope.tooltipMessage = translatedSlideTabMessages[0];
            });
          }
        };
      }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/directives/slidable/slidable.directive.js